import { ExportListResponse } from '@core/interface/export-list.interface';
import { ExportPurchaseOrderRequestDto } from '@domain/purchase-order/dtos/export-purchase-order.request.dto';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { PurchaseOrderService } from '@core/services/entities/purchase-order.service';
import { PurchaseOrderResponseDto } from '@domain/purchase-order/dtos/purchase-order.response.dto';
import { CreatePurchaseOrderRequestDto } from '@domain/purchase-order/dtos/create-purchase-order.request.dto';
import { ListPurchaseOrderRequestDto } from '@domain/purchase-order/dtos/list-purchase-order.request.dto';
import { UpdateStatePurchaseOrderRequestDto } from '@domain/purchase-order/dtos/update-state-purchase-order.request.dto';
import { SummaryPurchaseOrderRequestDto } from '@domain/purchase-order/dtos/summary-purchase-order.request.dto';
import { SummaryPurchaseOrderResponseDto } from '@domain/purchase-order/dtos/summary-purchase-order.response.dto';
import { PurchaseOrderRepository } from '@domain/purchase-order/repositories/purchase-order.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderRepositoryService implements PurchaseOrderRepository {
  constructor(private purchaseOrderService: PurchaseOrderService) {}

  create(
    request: CreatePurchaseOrderRequestDto,
  ): Observable<ApiResponse<PurchaseOrderResponseDto>> {
    return this.purchaseOrderService.create(request);
  }

  show(request: RefId): Observable<ApiResponse<PurchaseOrderResponseDto>> {
    return this.purchaseOrderService.show(request);
  }

  list(
    request: ListPurchaseOrderRequestDto,
  ): Observable<ApiResponse<PageableResponse<PurchaseOrderResponseDto>>> {
    return this.purchaseOrderService.list(request);
  }

  updateState(
    request: UpdateStatePurchaseOrderRequestDto,
  ): Observable<ApiResponse<PurchaseOrderResponseDto>> {
    return this.purchaseOrderService.updateState(request.refId, request.state);
  }

  summary(
    request: SummaryPurchaseOrderRequestDto,
  ): Observable<ApiResponse<SummaryPurchaseOrderResponseDto>> {
    return this.purchaseOrderService.summary(request);
  }

    export(
        request: ExportPurchaseOrderRequestDto,
    ): Observable<ApiResponse<ExportListResponse>> {
        return this.purchaseOrderService.export(request);
    }
}
